module.exports = scout;